import React from 'react';
import styled from 'styled-components';

const BallContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px;
  padding: 20px;
`;

const Ball = styled.div`
  width: ${props => props.size || '200px'};
  height: ${props => props.size || '200px'};
  border-radius: 50%;
  background: radial-gradient(circle at 30% 30%, #ff6b6b, #ee5a6f, #c44569);
  box-shadow: 
    inset -10px -10px 20px rgba(0, 0, 0, 0.3),
    inset 10px 10px 20px rgba(255, 255, 255, 0.2),
    0 20px 40px rgba(0, 0, 0, 0.3);
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 20%;
    left: 25%;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.4);
    filter: blur(10px);
  }
`;

const InfoText = styled.div`
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  color: white;
  font-size: 18px;
  font-weight: bold;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  background: rgba(0, 0, 0, 0.3);
  padding: 10px 20px;
  border-radius: 8px;
`;

export const TestBallWidget = ({ size = '200px', zoneName = 'Test Zone' }) => {
  return (
    <BallContainer>
      <Ball size={size} />
      <InfoText>{zoneName}</InfoText>
    </BallContainer>
  );
};

export default TestBallWidget;
